import { createTheme } from '@mui/material/styles'
import { componentOverrides } from './components'
import * as DT from './designTokens'
import { APP_FONT_STACK } from './fontFamily'

export { APP_FONT_STACK } from './fontFamily'
export * from './designTokens'

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: DT.palettePrimaryMain,
      dark: DT.palettePrimaryDark,
      light: DT.palettePrimaryLight,
    },
    secondary: {
      main: DT.paletteSecondaryInk,
      light: '#334155',
      dark: '#020617',
    },
    success: { main: DT.paletteSuccessMain },
    error: { main: DT.paletteErrorMain },
    warning: { main: DT.paletteWarningMain },
    info: { main: DT.paletteInfoMain },
    background: {
      default: DT.surfaceBackground,
      paper: DT.surfacePaper,
    },
    text: {
      primary: DT.textPrimary,
      secondary: DT.textSecondary,
      disabled: DT.textDisabled,
    },
    divider: DT.borderDefault,
  },
  typography: {
    fontFamily: APP_FONT_STACK,
    h1: { fontSize: '3rem', fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.25 },
    h3: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.3 },
    h4: { fontSize: '1.25rem', fontWeight: 700, lineHeight: 1.35 },
    h5: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.45 },
    body1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.43 },
    caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.34 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 8 },
  components: componentOverrides,
})
